const DEFAULT_HOUR = 20;

// A Match Day defaults to today at 20:00 local time. Stored as an ISO string: a moment
// instance in redux state was mutable, and Step0 mutated it through props.
export function defaultMatchDayDate(now: Date = new Date()): string {
  const date = new Date(now.getTime());
  date.setHours(DEFAULT_HOUR, 0, 0, 0);
  return date.toISOString();
}
